import React, { useState } from 'react';
import { ChevronDownIcon, SquareIcon } from 'lucide-react';
import { states } from '../data/states';
import { services } from '../data/services';
export function Footer({
  onNavigate
}: {
  onNavigate?: (path: string) => void;
}) {
  const currentYear = new Date().getFullYear();
  const [openSection, setOpenSection] = useState<string | null>(null);
  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };
  const popularStates = states.filter(s => ['CA', 'TX', 'FL', 'NY', 'PA', 'IL', 'OH', 'GA', 'NC', 'MI'].includes(s.abbreviation));
  const popularServices = services.slice(0, 10);
  const partnerCategories = [{
    category: 'Window Replacements',
    partners: [{
      name: 'Champion',
      path: '/champion/windows'
    }, {
      name: 'DaBella',
      path: '/dabella/windows'
    }]
  }, {
    category: 'Sunrooms',
    partners: [{
      name: 'Champion',
      path: '/champion/sunrooms'
    }]
  }, {
    category: 'Siding',
    partners: [{
      name: 'Champion',
      path: '/champion/siding'
    }, {
      name: 'DaBella',
      path: '/dabella/siding'
    }]
  }, {
    category: 'Other Exterior',
    partners: [{
      name: 'Champion',
      path: '/champion/other-exterior'
    }]
  }, {
    category: 'Roofing',
    partners: [{
      name: 'DaBella',
      path: '/dabella/roofing'
    }]
  }, {
    category: 'Bathroom Remodels',
    partners: [{
      name: 'DaBella',
      path: '/dabella/baths'
    }]
  }, {
    category: 'HVAC',
    partners: []
  }, {
    category: 'Solar',
    partners: []
  }];
  return <footer className="bg-slate-950 pt-16 pb-8 border-t border-slate-900" data-id="element-909">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-910">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-911">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-912">
            <a href="#" onClick={e => {
            e.preventDefault();
            onNavigate?.('/');
          }} className="text-2xl font-extrabold text-white tracking-tight mb-4 block" data-id="element-913">
              FindService<span className="text-amber-500" data-id="element-914">Quotes</span>
            </a>
            <p className="text-slate-400 leading-relaxed" data-id="element-915">
              Connecting homeowners with trusted local professionals since 2019.
            </p>
          </div>

          {/* Services Column */}
          <div data-id="element-916">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-917">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-918">
              {[{
              name: 'Walk-In Showers',
              slug: 'walk-in-showers'
            }, {
              name: 'Walk-In Tubs',
              slug: 'walk-in-tubs'
            }, {
              name: 'Window Replacement',
              slug: 'window-replacement'
            }, {
              name: 'Roofing',
              slug: 'roofing'
            }, {
              name: 'Siding',
              slug: 'siding'
            }, {
              name: 'Solar Panels',
              slug: 'solar'
            }, {
              name: 'Bathroom Remodel',
              slug: 'bathroom-remodel'
            }, {
              name: 'Kitchen Remodel',
              slug: 'kitchen-remodel'
            }, {
              name: 'Flooring',
              slug: 'flooring'
            }, {
              name: 'HVAC',
              slug: 'hvac'
            }, {
              name: 'Plumbing',
              slug: 'plumbing'
            }, {
              name: 'Electrical',
              slug: 'electrical'
            }].map(item => <li key={item.slug} data-id="element-919">
                  <button onClick={() => onNavigate?.(`/near-me/${item.slug}`)} className="text-slate-400 hover:text-white transition-colors" data-id="element-920">
                    {item.name}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Content Column — moved from nav */}
          <div data-id="element-921">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-922">
              Content
            </h3>
            <div className="space-y-1" data-id="element-923">
              {/* States Accordion */}
              <div data-id="element-924">
                <button onClick={() => toggleSection('states')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-925">
                  <span className="font-medium" data-id="element-926">States</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'states' ? 'rotate-180' : ''}`} data-id="element-927" />
                </button>
                {openSection === 'states' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-928">
                    {popularStates.map(state => <button key={state.abbreviation} onClick={() => onNavigate?.(`/states/${state.slug}`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-929">
                        {state.name}
                      </button>)}
                    <button onClick={() => onNavigate?.('/states')} className="block text-sm font-semibold text-amber-500 hover:text-amber-400 transition-colors pt-1" data-id="element-930">
                      View All States →
                    </button>
                  </div>}
              </div>

              {/* Cost Guides Accordion */}
              <div data-id="element-931">
                <button onClick={() => toggleSection('costs')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-932">
                  <span className="font-medium" data-id="element-933">Cost Guides</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'costs' ? 'rotate-180' : ''}`} data-id="element-934" />
                </button>
                {openSection === 'costs' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-935">
                    {popularServices.map(service => <button key={service.slug} onClick={() => onNavigate?.(`/costs/${service.slug}`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-936">
                        {service.name}
                      </button>)}
                    <button onClick={() => onNavigate?.('/costs')} className="block text-sm font-semibold text-amber-500 hover:text-amber-400 transition-colors pt-1" data-id="element-937">
                      View All Cost Guides →
                    </button>
                  </div>}
              </div>

              {/* Compare Services Accordion */}
              <div data-id="element-938">
                <button onClick={() => toggleSection('compare')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-939">
                  <span className="font-medium" data-id="element-940">Compare Services</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'compare' ? 'rotate-180' : ''}`} data-id="element-941" />
                </button>
                {openSection === 'compare' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-942">
                    {popularServices.map(service => <button key={service.slug} onClick={() => onNavigate?.(`/${service.slug}/best`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-943">
                        Best {service.name}
                      </button>)}
                  </div>}
              </div>

              {/* Advertorials Accordion */}
              <div data-id="element-944">
                <button onClick={() => toggleSection('advertorials')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-945">
                  <span className="font-medium" data-id="element-946">Advertorials</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'advertorials' ? 'rotate-180' : ''}`} data-id="element-947" />
                </button>
                {openSection === 'advertorials' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-948">
                    {popularServices.map(service => <button key={service.slug} onClick={() => onNavigate?.(`/${service.slug}/articles/advertorial`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-949">
                        {service.name}
                      </button>)}
                  </div>}
              </div>

              {/* Reviews Link */}
              <div data-id="element-950">
                <button onClick={() => {
                onNavigate?.('/');
                setTimeout(() => document.getElementById('reviews')?.scrollIntoView({
                  behavior: 'smooth'
                }), 100);
              }} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors" data-id="element-951">
                  <span className="font-medium" data-id="element-952">Reviews</span>
                </button>
              </div>

              {/* Partners Accordion */}
              <div data-id="element-953">
                <button onClick={() => toggleSection('partners')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-954">
                  <span className="font-medium" data-id="element-955">Partners</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'partners' ? 'rotate-180' : ''}`} data-id="element-956" />
                </button>
                {openSection === 'partners' && <div className="pl-3 pb-3 space-y-3 border-l border-slate-800 ml-1" data-id="element-957">
                    {partnerCategories.map(cat => <div key={cat.category} data-id="element-958">
                        <div className="text-[11px] font-bold text-slate-600 uppercase tracking-wider mb-1" data-id="element-959">
                          {cat.category}
                        </div>
                        {cat.partners.length > 0 ? cat.partners.map(partner => <button key={partner.name} onClick={() => onNavigate?.(partner.path)} className="flex items-center gap-2 text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-960">
                              <SquareIcon className="w-3 h-3 text-slate-600" data-id="element-961" />
                              {partner.name}
                            </button>) : <span className="text-xs text-slate-600 italic" data-id="element-962">
                            Coming soon
                          </span>}
                      </div>)}
                  </div>}
              </div>
            </div>
          </div>

          {/* Support Column */}
          <div data-id="element-963">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-964">
              Support
            </h3>
            <ul className="space-y-3" data-id="element-965">
              {['Help Center', 'Contact Us', 'Privacy Policy', 'Terms of Service'].map(item => <li key={item} data-id="element-966">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-967">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-968">
          <p className="text-slate-500 text-sm text-center md:text-left" data-id="element-969">
            &copy; {currentYear} FindServiceQuotes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}